interface FormatUSDOptions {
  showPlusSign?: boolean;
}

export const formatUSD = (amount: number, options?: FormatUSDOptions): string => {
  const getFirstPart = () => {
    if (amount < 0) {
      return '-';
    } else if (amount > 0 && options?.showPlusSign) {
      return '+';
    }
    return '';
  };

  return `${getFirstPart()}$${Math.abs(amount).toLocaleString('en-US', {
    maximumFractionDigits: 2,
  })}`;
};
